/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IPipe {
        name: string;
        href: string;
        connectionRoomHref: string;
        numOrder: number;
        source: string;
        sourceName?: string;
        sourceConnectedTo: string;
        destinations: IDestination[];
        creationDate: Date;
        disconnectedDestination?: number;
        sourceVideoFeed: IVideoFeed;
        destinationVideoFeed: IVideoFeed[];
    }
    
    export interface IDestination {
        id?: number;
        destination: string;
        name?: string;
        status: boolean; // playing = true, paused = false
        streamPipeHref: string;
        empty: boolean;
        locked: boolean;
    }

    export class Pipe implements IPipe {
        public name: string;
        public href: string;
        public connectionRoomHref: string;
        public creationDate: Date;
        public source: string;
        public sourceName: string;
        public sourceConnectedTo: string;
        public destinations: IDestination[];
        public numOrder: number;
        public disconnectedDestination: number;
        public sourceVideoFeed: IVideoFeed;
        public destinationVideoFeed: IVideoFeed[];

        public static Empty(): Pipe {
            return new Pipe();
        }

        public static EmptyWith(numDestinations: number): Pipe {
            if (numDestinations === 1)
                return Pipe.Empty();
            else {
                let pipe: Pipe = new Pipe();
                pipe.destinations = [];
                for (let i: number = 0; i < numDestinations; i++) {
                    pipe.destinations.push(this.EmptyDestination());
                }
                return pipe;
            }
        }

        public static EmptyDestination(): IDestination {
            return { destination: '', name: undefined, status: false , streamPipeHref: undefined, empty: true, locked: false };
        }

        public static fillDestinationsUntil(pipe: IPipe, capacity: number): number {
            let diff: number = capacity - pipe.destinations.length;
            for (let i: number = 1; i < capacity - pipe.destinations.length ; i++) {
                pipe.destinations.push(Pipe.EmptyDestination());
            }
            return diff;
        }

        constructor() {
            // empty constructor
            this.name = '';
            this.href = '';
            this.connectionRoomHref = '';
            this.creationDate = new Date();
            this.source = '';
            this.destinations = [Pipe.EmptyDestination()];
            this.numOrder = undefined;
            this.disconnectedDestination = -1;
            this.sourceVideoFeed = VideoFeed.Empty();
            this.destinationVideoFeed = [];
        }
    }
}